import {
  GET_ALERTS_SUCCESS,
  GET_ALERTS_FAILURE,
  MARK_ALERT_READ_SUCCESS,
  MARK_ALERT_READ_FAILURE,
  CLEAR_ALERT_SUCCESS,
  CLEAR_ALERT_FAILURE,
  CLEAR_ALL_ALERTS_SUCCESS,
  CLEAR_ALL_ALERTS_FAILURE,
} from './alerts.constants'

const initialState = {
  list: [],
  unreadCount: 0,
  totalCount: 0,
  pageSize: 6,
  page: 1,
  error: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ALERTS_SUCCESS:
      return {
        ...state,
        page: action.alerts.page,
        list: action.alerts.list,
        unreadCount: action.alerts.unreadCount,
        totalCount: action.alerts.totalCount,
        error: '',
      }
    case GET_ALERTS_FAILURE:
      return { ...state, error: action.error.message }
    case MARK_ALERT_READ_SUCCESS:
      return {
        ...state,
        unreadCount: action.alerts.unreadCount,
        list: action.alerts.list,
      }
    case MARK_ALERT_READ_FAILURE:
      return state
    case CLEAR_ALERT_SUCCESS:
      return { ...state, list: action.alerts.list, unreadCount: action.alerts.unreadCount }
    case CLEAR_ALERT_FAILURE:
      return state
    case CLEAR_ALL_ALERTS_SUCCESS:
      return initialState
    case CLEAR_ALL_ALERTS_FAILURE:
      return state
    default:
      return state
  }
}
